import React, { useState } from 'react';
import {
    Box,
    Container,
    Grid,
    Typography,
    Tabs,
    Tab,
    Card,
    CardContent,
    Avatar,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Button,
    useMediaQuery
} from '@mui/material';
import {
    Business,
    MonetizationOn,
    BusinessCenter,
    School,
    Build,
    Public,
    GroupWork,
    People,
    ChevronRight,
    ArrowRightAlt,
    ArrowForward,
    CheckCircle,
    PeopleAlt
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import { fadeInUp, getTheme, staggerContainer, fadeInRight } from '../../theme/theme';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import { CTASection } from '../services/CTASection';

import hrms from '../../assets/images/hrm.jpg';
import healthcare from '../../assets/images/healthcare.avif';
import education from '../../assets/images/education.avif';
import retail from '../../assets/images/retail.jpg';
import manufacturing from '../../assets/images/manufacturing.png';
import government from '../../assets/images/government.webp';
import enterprise from '../../assets/images/enterprise.avif';
import smbs from '../../assets/images/smbs.webp';
import startup from '../../assets/images/startup.png';
import { useNavigate } from 'react-router-dom';
import heroImage from '../../assets/images/saas_analytics_insights_unveiled_cover.jpg';
import SolutionsHero from './solution-hero';

// TabPanel component
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const HeroSection = ({ theme }) => (
    <>
        <Box
            component="section"
            sx={{
                pt: { xs: 10, md: 16 },
                pb: { xs: 10, md: 14 },
                position: 'relative',
                overflow: 'hidden',
                // background: theme.palette.mode === 'dark'
                //   ? 'linear-gradient(135deg, rgba(10, 10, 26, 0.9) 0%, rgba(26, 26, 46, 0.9) 100%)'
                //   : 'linear-gradient(135deg, rgba(245, 247, 255, 0.9) 0%, rgba(230, 235, 255, 0.9) 100%)',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    // background: theme.palette.mode === 'dark'
                    //   ? 'radial-gradient(circle at 20% 50%, rgba(106, 27, 255, 0.15) 0%, transparent 60%)'
                    //   : 'radial-gradient(circle at 20% 50%, rgba(106, 27, 255, 0.08) 0%, transparent 60%)',
                    zIndex: 1
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    width: '70%',
                    height: '70%',
                    // background: theme.palette.mode === 'dark'
                    //   ? 'radial-gradient(circle at 80% 80%, rgba(0, 229, 255, 0.1) 0%, transparent 50%)'
                    //   : 'radial-gradient(circle at 80% 80%, rgba(0, 229, 255, 0.05) 0%, transparent 50%)',
                    zIndex: 1
                }
            }}
        >
            <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
                <Grid container spacing={{ xs: 6, md: 8 }} alignItems="center" justifyContent="space-between">
                    <Grid item xs={12} md={6} lg={5}>
                        <motion.div
                            initial="hidden"
                            animate="visible"
                            variants={fadeInRight}
                        >
                            <Box sx={{ position: 'relative' }}>
                                <Typography
                                    // variant="overline"
                                    sx={{
                                        display: 'inline-block',
                                        color: 'secondary.main',
                                        fontWeight: 700,
                                        letterSpacing: 1.8,
                                        mb: 2,
                                        position: 'relative',
                                        pl: 1,
                                        '&::before': {
                                            content: '""',
                                            position: 'absolute',
                                            left: -10,
                                            top: '50%',
                                            width: 30,
                                            height: 2,
                                            backgroundColor: theme.palette.secondary.main,
                                            transform: 'translateY(-50%)'
                                        }
                                    }}
                                >
                                    OUR SOLUTIONS
                                </Typography>
                            </Box>

                            <Typography
                                variant="h1"
                                component="h1"
                                gutterBottom
                                sx={{
                                    fontWeight: 800,
                                    mb: { xs: 3, md: 4 },
                                    background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    backgroundClip: 'text', // For Firefox
                                    textFillColor: 'transparent', // For Firefox
                                    fontSize: { xs: '2.75rem', sm: '3.25rem', md: '3.75rem', lg: '4.25rem' },
                                    lineHeight: 1.1
                                }}
                            >
                                Industry-Specific Technology Solutions
                            </Typography>
                            <Typography
                                variant="h5"
                                component="p"
                                color="text.secondary"
                                paragraph
                                sx={{
                                    mb: 5,
                                    maxWidth: '90%',
                                    fontSize: { xs: '1.1rem', md: '1.25rem' },
                                    lineHeight: 1.6,
                                    fontWeight: 400
                                }}
                            >
                                We develop tailored solutions that address the unique challenges and opportunities in your industry.
                            </Typography>

                            <Box sx={{
                                display: 'flex',
                                gap: 3,
                                flexWrap: { xs: 'wrap', sm: 'nowrap' }
                            }}>
                                {/* <Button
                                    variant="contained"
                                    size="large"
                                    href="#service-categories"
                                    sx={{
                                        px: { xs: 3, md: 5 },
                                        py: 2,
                                        fontWeight: 600,
                                        background: theme.palette.gradients.primary || `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                        borderRadius: '50px',
                                        '&:hover': {
                                            transform: 'translateY(-3px)',
                                            boxShadow: `0 8px 25px ${theme.palette.primary.main}40`
                                        },
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    Explore Solutions
                                </Button> */}

                                <Button
                                    variant="outlined"
                                    size="large"
                                    href="/contact"
                                    sx={{
                                        px: { xs: 3, md: 5 },
                                        py: 2,
                                        fontWeight: 600,
                                        borderWidth: 2,
                                        borderRadius: '50px',
                                        borderColor: theme.palette.primary.main,
                                        '&:hover': {
                                            borderWidth: 2,
                                            borderColor: theme.palette.primary.main,
                                            transform: 'translateY(-3px)',
                                            boxShadow: `0 8px 25px ${theme.palette.primary.main}20`
                                        },
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    Contact Us
                                </Button>
                            </Box>
                        </motion.div>
                    </Grid>

                    {/* <Grid item xs={12} md={6} lg={6}>
                        <motion.div
                            initial={{ opacity: 0, y: 60, scale: 0.95 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
                            whileHover={{ scale: 1.03 }}
                        >
                            <Box
                                sx={{
                                    position: 'relative',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: { xs: -15, md: -25 },
                                        left: { xs: -15, md: -25 },
                                        width: { xs: 150, md: 200 },
                                        height: { xs: 150, md: 200 },
                                        borderRadius: '50%',
                                        background: `linear-gradient(45deg, ${theme.palette.primary.main}20, ${theme.palette.secondary.main}20)`,
                                        zIndex: -1
                                    },
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        bottom: { xs: -20, md: -30 },
                                        right: { xs: -20, md: -30 },
                                        width: { xs: 180, md: 250 },
                                        height: { xs: 180, md: 250 },
                                        borderRadius: '50%',
                                        background: `linear-gradient(45deg, ${theme.palette.secondary.main}20, ${theme.palette.primary.main}20)`,
                                        zIndex: -1
                                    }
                                }}
                            >
                                <Box
                                    component="img"
                                    src={heroImage}
                                    alt="Our Solutions"
                                    sx={{
                                        width: '964px',
                                        height: '412px',
                                        maxWidth: '964px',
                                        maxHeight: '412px',
                                        borderRadius: { xs: 3, md: 4 },
                                        boxShadow: `0 25px 50px ${theme.palette.mode === 'dark' ? '#00000070' : '#6a1bff30'}`,
                                        border: `1px solid ${theme.palette.mode === 'dark' ? '#ffffff15' : '#6a1bff15'}`,
                                        transform: 'perspective(1500px) rotateY(-8deg)',
                                        transition: 'all 0.4s ease',
                                        filter: theme.palette.mode === 'dark' ? 'brightness(0.9)' : 'none',
                                        '&:hover': {
                                            transform: 'perspective(1500px) rotateY(-5deg) scale(1.02)',
                                            boxShadow: `0 30px 60px ${theme.palette.mode === 'dark' ? '#00000080' : '#6a1bff40'}`,
                                        }
                                    }}
                                />
                            </Box>
                        </motion.div>
                    </Grid> */}
                </Grid>
            </Container>
        </Box>

    </>
);



export const Solutions = ({ mode }) => {
    const [value, setValue] = useState(0);
    const theme = getTheme(mode);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
    const navigate = useNavigate();
    const [particlesLoaded, setParticlesLoaded] = useState(false);

    const particlesInit = async (engine) => {
        await loadFull(engine);
    };

    const particlesLoaded$ = async (container) => {
        setParticlesLoaded(true);
    };


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };



    const industrySolutions = [
        
        {
            name: 'Retail',
            icon: <BusinessCenter />,
            solutions: [
                'E-commerce Platforms',
                'POS Systems',
                'Inventory Management',
                'Customer Loyalty Programs',
                'Retail Analytics'
            ],
            image: retail
        },
        
        {
            name: 'Manufacturing',
            icon: <Build />,
            solutions: [
                'Supply Chain Management',
                'Quality Control Systems',
                'Predictive Maintenance',
                'Industrial IoT',
                'Manufacturing Analytics'
            ],
            image: manufacturing
        },
        {
            name: 'HR & Payroll Management',
            icon: <PeopleAlt />,
            solutions: [
                'Employee Onboarding',
                'Attendance & Leave Tracking',
                'Payroll Processing',
                'Performance Management',
                'HR Analytics & Reporting'
            ],
            image: hrms
        },
        {
            name: 'Healthcare',
            icon: <Business />,
            solutions: [
                'Electronic Health Records (EHR)',
                'Telemedicine Platforms',
                'Patient Portals',
                'Medical Imaging Analysis',
                'Healthcare Analytics'
            ],
            image: healthcare
        },
        {
            name: 'Government',
            icon: <Public />,
            solutions: [
                'Citizen Portals',
                'Document Management',
                'Case Management',
                'Regulatory Compliance',
                'Government Analytics'
            ],
            image: government
        },
        {
            name: 'Education',
            icon: <School />,
            solutions: [
                'Learning Management Systems',
                'Student Portals',
                'Online Assessment Tools',
                'Virtual Classrooms',
                'Education Analytics'
            ],
            image: education
        }
        
    ];


    // Solutions by business size
    const businessSizeSolutions = [
        {
            name: 'Startups',
            icon: <GroupWork />,
            solutions: [
                'MVP Development',
                'Product Strategy',
                'Investor Pitch Decks',
                'Scalable Architecture',
                'Growth Hacking'
            ],
            image: startup
        },
        {
            name: 'SMBs',
            icon: <Business />,
            solutions: [
                'Process Automation',
                'Digital Transformation',
                'Customer Engagement',
                'Data Analytics',
                'Cloud Migration'
            ],
            image: smbs
        },
        {
            name: 'Enterprise',
            icon: <BusinessCenter />,
            solutions: [
                'Legacy Modernization',
                'Enterprise Integration',
                'Digital Innovation',
                'Global Scalability',
                'Enterprise Architecture'
            ],
            image: enterprise
        }
    ];

    return (<>

        <Box sx={{
            bgcolor: mode === 'light' ? 'background.default' : 'background.default',
            color: 'text.primary',
            position: 'relative',
            overflow: 'hidden',
            pb: 8
        }}>
            <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0 }}>
                <Particles
                    id="tsparticles"
                    init={particlesInit}
                    loaded={particlesLoaded$}
                    options={{
                        fullScreen: { enable: false },
                        background: {
                            color: {
                                value: 'transparent',
                            },
                        },
                        fpsLimit: 60,
                        particles: {
                            color: {
                                value: mode === 'light' ? '#6a1bff' : '#00e5ff',
                            },
                            links: {
                                color: mode === 'light' ? '#6a1bff' : '#00e5ff',
                                distance: 150,
                                enable: true,
                                opacity: 0.3,
                                width: 1,
                            },
                            collisions: {
                                enable: true,
                            },
                            move: {
                                direction: 'none',
                                enable: true,
                                outModes: {
                                    default: 'bounce',
                                },
                                random: false,
                                speed: 0.5,
                                straight: false,
                            },
                            number: {
                                density: {
                                    enable: true,
                                    area: 800,
                                },
                                value: 40,
                            },
                            opacity: {
                                value: 0.3,
                            },
                            shape: {
                                type: 'circle',
                            },
                            size: {
                                value: { min: 1, max: 3 },
                            },
                        },
                        detectRetina: true,
                    }}
                    style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        zIndex: 0
                    }}
                />
            </Box>

            <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
                <SolutionsHero mode={mode} />
                <Box sx={{ borderBottom: 0, mb: 8, textAlign: 'center' }}>
                    <Typography
                        variant="h2"
                        component="h2"
                        sx={{
                            mb: 3,
                            background: 'linear-gradient(90deg, #6200ea 0%, #3f51b5 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            fontWeight: 700
                        }}
                    >
                        Our Solutions
                    </Typography>
                    <Typography variant="h6" color="text.secondary" sx={{ mb: 5, maxWidth: '800px', mx: 'auto' }}>
                        Choose the solution that fits your business needs
                    </Typography>

                    {/* <Box
                        sx={{
                            display: 'inline-flex',
                            bgcolor: 'background.default',
                            p: 1,
                            borderRadius: 10,
                            boxShadow: '0 4px 20px rgba(98, 0, 234, 0.1)'
                        }}
                    >
                    
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                            aria-label="solution tabs"
                            sx={{
                                '& .MuiTabs-indicator': {
                                    backgroundColor: 'transparent'
                                },
                                '& .Mui-selected': {
                                    backgroundColor: '#6200ea',
                                    color: mode == 'dark'?'white':'black',
                                    borderRadius: '30px',
                                    transition: 'all 0.3s ease',
                                },
                                '& .MuiTab-root': {
                                    borderRadius: '30px',
                                    mx: 0.5,
                                    transition: 'all 0.3s ease',
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    minHeight: '48px'
                                }
                            }}
                        >
                            <Tab
                                label="By Industry"
                                icon={<Business sx={{ color: value === 0 ? 'white' : '#6200ea' }} />}
                                iconPosition="start"
                            />
                            <Tab
                                label="By Business Size"
                                icon={<People sx={{ color: value === 1 ? 'white' : '#6200ea' }} />}
                                iconPosition="start"
                            />
                        </Tabs>
                    </Box> */}

                    <Box
      sx={{
        display: 'inline-flex',
        bgcolor: 'background.default',
        p: 1,
        borderRadius: 10,
        boxShadow: '0 4px 20px rgba(98, 0, 234, 0.1)'
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="solution tabs"
        sx={{
          '& .MuiTabs-indicator': {
            backgroundColor: 'transparent'
          },
          '& .MuiTab-root': {
            borderRadius: '30px',
            mx: 0.5,
            transition: 'all 0.3s ease',
            fontWeight: 600,
            textTransform: 'none',
            fontSize: '1rem',
            minHeight: '48px',
            color: mode === 'dark' ? '#ffffff' : '#424242',
            '&.Mui-selected': {
              backgroundColor: '#6200ea',
              color: '#ffffff',
              '& .MuiSvgIcon-root': {
                color: '#ffffff',
              }
            }
          }
        }}
      >
        <Tab
          label={<span style={{ color: 'inherit' }}>By Industry</span>}
          icon={<Business />}
          iconPosition="start"
        />
        <Tab
          label={<span style={{ color: 'inherit' }}>By Business Size</span>}
          icon={<People />}
          iconPosition="start"
        />
      </Tabs>
    </Box>
                </Box>

                <TabPanel value={value} index={0}>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        variants={staggerContainer}
                    >
                        <Box sx={{ py: { xs: 4, md: 6 } }}>
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: {
                                    xs: '1fr',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)'
                                },
                                gap: { xs: 4, md: 5 },
                            }}>
                                {industrySolutions.map((solution, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <motion.div variants={fadeInUp}>
                                            <Card sx={{
                                                height: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                transition: 'all 0.3s ease',
                                                borderRadius: '16px',
                                                overflow: 'hidden',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                                                '&:hover': {
                                                    transform: 'translateY(-8px)',
                                                    boxShadow: '0 20px 40px rgba(98, 0, 234, 0.15)',
                                                },
                                                position: 'relative',
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '6px',
                                                    background: `linear-gradient(90deg, #6200ea ${index * 30}%, #03dac6 100%)`,
                                                }
                                            }}>
                                                <Box
                                                    sx={{
                                                        position: 'relative',
                                                        height: 220,
                                                        overflow: 'hidden'
                                                    }}
                                                >
                                                    <Box
                                                        component="img"
                                                        src={solution.image}
                                                        alt={solution.name}
                                                        sx={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            transition: 'transform 0.5s ease',
                                                            filter: 'brightness(0.95)',
                                                            '&:hover': {
                                                                transform: 'scale(1.05)',
                                                                filter: 'brightness(1)'
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                                <CardContent sx={{
                                                    flexGrow: 1,
                                                    p: 3,
                                                    pt: 4
                                                }}>
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        mb: 3,
                                                    }}>
                                                        <Avatar
                                                            sx={{
                                                                width: 56,
                                                                height: 56,
                                                                mr: 2,
                                                                background: `linear-gradient(135deg, #6200ea ${index * 30}%, #03dac6 100%)`,
                                                                color: 'white',
                                                                boxShadow: '0 8px 16px rgba(98, 0, 234, 0.2)',
                                                            }}
                                                        >
                                                            {solution.icon}
                                                        </Avatar>
                                                        <Typography
                                                            variant="h5"
                                                            component="h3"
                                                            sx={{
                                                                fontWeight: 700,
                                                                color: theme.palette.mode === 'dark' ? '#fff' : '#1a237e',
                                                                position: 'relative',
                                                                '&::after': {
                                                                    content: '""',
                                                                    position: 'absolute',
                                                                    bottom: -8,
                                                                    left: 0,
                                                                    width: '40px',
                                                                    height: '3px',
                                                                    background: `linear-gradient(90deg, #6200ea ${index * 30}%, #03dac6 100%)`,
                                                                }
                                                            }}
                                                        >
                                                            {solution.name}
                                                        </Typography>
                                                    </Box>
                                                    <List dense sx={{ mb: 2 }}>
                                                        {solution.solutions.map((item, i) => (
                                                            <ListItem
                                                                key={i}
                                                                disableGutters
                                                                sx={{
                                                                    mb: 1.5,
                                                                    py: 0.5,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(98, 0, 234, 0.04)',
                                                                        borderRadius: '8px',
                                                                        transform: 'translateX(4px)',
                                                                        transition: 'all 0.2s ease'
                                                                    }
                                                                }}
                                                            >
                                                                <ListItemIcon sx={{
                                                                    minWidth: 32,
                                                                    color: '#6200ea'
                                                                }}>
                                                                    <CheckCircle fontSize="small" />
                                                                </ListItemIcon>
                                                                <ListItemText
                                                                    primary={item}
                                                                    primaryTypographyProps={{
                                                                        fontWeight: 500,
                                                                        fontSize: '0.95rem'
                                                                    }}
                                                                />
                                                            </ListItem>
                                                        ))}
                                                    </List>
                                                    {/* <Button
                                                            variant="contained"
                                                            endIcon={<ArrowForward />}
                                                            sx={{
                                                                mt: 3,
                                                                background: `linear-gradient(90deg, #6200ea ${index * 30}%, #03dac6 100%)`,
                                                                color: 'white',
                                                                borderRadius: '30px',
                                                                py: 1.25,
                                                                px: 3,
                                                                boxShadow: '0 4px 16px rgba(98, 0, 234, 0.2)',
                                                                '&:hover': {
                                                                    boxShadow: '0 8px 16px rgba(98, 0, 234, 0.4)',
                                                                    transform: 'translateY(-2px)'
                                                                }
                                                            }}
                                                        >
                                                            Learn More
                                                        </Button> */}
                                                </CardContent>
                                            </Card>
                                        </motion.div>
                                    </Grid>
                                ))}
                            </Box>
                        </Box>
                    </motion.div>
                </TabPanel>

                <TabPanel value={value} index={1}>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        variants={staggerContainer}
                    >
                        <Box sx={{ py: { xs: 4, md: 6 } }}>
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: {
                                    xs: '1fr',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)'
                                },
                                gap: { xs: 4, md: 5 },
                            }}>
                                {businessSizeSolutions.map((solution, index) => (
                                    <Grid item xs={12} md={4} key={index}>
                                        <motion.div variants={fadeInUp}>
                                            <Card sx={{
                                                height: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                transition: 'all 0.3s ease',
                                                borderRadius: '16px',
                                                overflow: 'hidden',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                                                '&:hover': {
                                                    transform: 'translateY(-8px)',
                                                    boxShadow: '0 20px 40px rgba(98, 0, 234, 0.15)',
                                                },
                                                position: 'relative',
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '6px',
                                                    background: `linear-gradient(90deg, #6200ea ${index * 30}%, #03dac6 100%)`,
                                                }
                                            }}>
                                                <Box
                                                    sx={{
                                                        position: 'relative',
                                                        height: 220,
                                                        overflow: 'hidden'
                                                    }}
                                                >
                                                    <Box
                                                        component="img"
                                                        src={solution.image}
                                                        alt={solution.name}
                                                        sx={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            transition: 'transform 0.5s ease',
                                                            filter: 'brightness(0.95)',
                                                            '&:hover': {
                                                                transform: 'scale(1.05)',
                                                                filter: 'brightness(1)'
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                                <CardContent sx={{
                                                    flexGrow: 1,
                                                    p: 3,
                                                    pt: 4
                                                }}>
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        mb: 3,
                                                    }}>
                                                        <Avatar
                                                            sx={{
                                                                width: 56,
                                                                height: 56,
                                                                mr: 2,
                                                                background: `linear-gradient(135deg, #6200ea ${index * 30}%, #03dac6 100%)`,
                                                                color: 'white',
                                                                boxShadow: '0 8px 16px rgba(98, 0, 234, 0.2)',
                                                            }}
                                                        >
                                                            {solution.icon}
                                                        </Avatar>
                                                        <Typography
                                                            variant="h5"
                                                            component="h3"
                                                            sx={{
                                                                fontWeight: 700,
                                                                color: theme.palette.mode === 'dark' ? '#fff' : '#1a237e',
                                                                position: 'relative',
                                                                '&::after': {
                                                                    content: '""',
                                                                    position: 'absolute',
                                                                    bottom: -8,
                                                                    left: 0,
                                                                    width: '40px',
                                                                    height: '3px',
                                                                    background: `linear-gradient(90deg, #6200ea ${index * 30}%, #03dac6 100%)`,
                                                                }
                                                            }}
                                                        >
                                                            {solution.name}
                                                        </Typography>
                                                    </Box>
                                                    <List dense sx={{ mb: 2 }}>
                                                        {solution.solutions.map((item, i) => (
                                                            <ListItem
                                                                key={i}
                                                                disableGutters
                                                                sx={{
                                                                    mb: 1.5,
                                                                    py: 0.5,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(98, 0, 234, 0.04)',
                                                                        borderRadius: '8px',
                                                                        transform: 'translateX(4px)',
                                                                        transition: 'all 0.2s ease'
                                                                    }
                                                                }}
                                                            >
                                                                <ListItemIcon sx={{
                                                                    minWidth: 32,
                                                                    color: '#6200ea'
                                                                }}>
                                                                    <CheckCircle fontSize="small" />
                                                                </ListItemIcon>
                                                                <ListItemText
                                                                    primary={item}
                                                                    primaryTypographyProps={{
                                                                        fontWeight: 500,
                                                                        fontSize: '0.95rem'
                                                                    }}
                                                                />
                                                            </ListItem>
                                                        ))}
                                                    </List>
                                                    {/* <Button
                                                            variant="contained"
                                                            endIcon={<ArrowForward />}
                                                            sx={{
                                                                mt: 3,
                                                                background: `linear-gradient(90deg, #6200ea ${index * 30}%, #03dac6 100%)`,
                                                                color: 'white',
                                                                borderRadius: '30px',
                                                                py: 1.25,
                                                                px: 3,
                                                                boxShadow: '0 4px 16px rgba(98, 0, 234, 0.2)',
                                                                '&:hover': {
                                                                    boxShadow: '0 8px 16px rgba(98, 0, 234, 0.4)',
                                                                    transform: 'translateY(-2px)'
                                                                }
                                                            }}
                                                        >
                                                            Learn More
                                                        </Button> */}
                                                </CardContent>
                                            </Card>
                                        </motion.div>
                                    </Grid>
                                ))}
                            </Box>
                        </Box>
                    </motion.div>
                </TabPanel>
            </Container>
            <CTASection />
        </Box>



    </>
    );
};

// export default Solutions;